export default {
  displayName: 'Personal Information Table',
  allowableParents: ['Section'],
};
